/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Nav_CtaInputs */

const en_fc_nav_cta = /** @type {(inputs: Fc_Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download free`)
};

/**
* | output |
* | --- |
* | "Download free" |
*
* @param {Fc_Nav_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_nav_cta = /** @type {((inputs?: Fc_Nav_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Nav_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_nav_cta(inputs)
});
export { fc_nav_cta as "fc.nav.cta" }